import actions from '../actions';
import { call, takeLatest } from 'redux-saga/effects';
import reauthenticateWithPassword from '../../common/utils/reauthenticateWithPassword';

const showReauthenticationDialogSaga = takeLatest(actions.showReauthenticationDialog.type, function* ({
  payload: done,
}: ReturnType<typeof actions.showReauthenticationDialog>) {
  try {
    yield reauthenticateWithPassword();
  } catch (e) {
    //user canceled
    yield call(done);
  }
});

const sagas = [showReauthenticationDialogSaga];

export default sagas;
